<template>
  <section class="flow-kv">
    <div class="flow-kv-head">
      <h3>{{ title }}</h3>
      <button type="button" class="btn btn-sm" @click="addItem">Add</button>
    </div>
    <div v-if="localItems.length === 0" class="flow-kv-empty">Nothing added yet.</div>
    <div v-for="(item, index) in localItems" :key="`item-${index}`" class="flow-kv-row">
      <input v-model="item.key" class="input input-bordered" type="text" dir="ltr" :placeholder="keyLabel" @input="sendUpdate" />
      <input v-model="item.value" class="input input-bordered" type="text" dir="ltr" :placeholder="valueLabel" @input="sendUpdate" />
      <button type="button" class="btn btn-error btn-sm" title="Remove" @click="removeItem(index)">
        <Icon icon="tabler:trash" width="15" height="15" />
      </button>
    </div>
  </section>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Icon } from '@iconify/vue/dist/offline';

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  keyLabel: {
    type: String,
    default: 'Name'
  },
  valueLabel: {
    type: String,
    default: 'Value'
  },
  items: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['update']);
const localItems = ref([]);

watch(() => props.items, items => {
  localItems.value = JSON.parse(JSON.stringify(Array.isArray(items) === true ? items : []));
}, { immediate: true, deep: true });

function sendUpdate() {
  emit('update', JSON.parse(JSON.stringify(localItems.value)));
}

function addItem() {
  localItems.value.push({ key: '', value: '' });
  sendUpdate();
}

function removeItem(index) {
  localItems.value.splice(index, 1);
  sendUpdate();
}
</script>

<style scoped>
.flow-kv {
  margin-bottom: 1rem;
}

.flow-kv-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.45rem;
}

.flow-kv-head h3 {
  margin: 0;
  color: #334155;
  font-size: 0.7rem;
  font-weight: 700;
}

.flow-kv-empty {
  padding: 0.7rem;
  border: 1px dashed #cbd5e1;
  border-radius: 0.65rem;
  color: #64748b;
  font-size: 0.66rem;
  text-align: center;
}

.flow-kv-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  align-items: center;
}

.flow-kv-row + .flow-kv-row {
  margin-top: 0.4rem;
}

.flow-kv-row > * + * {
  margin-left: 0.4rem;
}

.flow-kv-row .input {
  width: 100%;
  min-width: 0;
  font-size: 0.7rem;
}
</style>
